import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, vModelText as _vModelText, withKeys as _withKeys, withDirectives as _withDirectives, unref as _unref, createVNode as _createVNode, vShow as _vShow, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  style: {"min-width":"400px","width":"40vw","margin":"auto","margin-top":"100px"},
  class: "border-box"
}
const _hoisted_2 = { class: "form-group" }
const _hoisted_3 = { class: "form-group" }
const _hoisted_4 = {
  class: "btn btn-lg btn-primary btn-block",
  disabled: ""
}
const _hoisted_5 = {
  key: 1,
  style: {"min-width":"400px","width":"40vw","margin":"auto","margin-top":"100px"},
  class: "border-box"
}
const _hoisted_6 = { class: "fg-color-blue" }

import { ref, computed, onMounted, watch } from 'vue'
    import { useRoute, useRouter } from 'vue-router'
    import ValidationError from '@common/Components/ValidationError.vue'
    import { useCurrentUserQueryV1 } from '@Organizations/Users/queries-vue-composables'
    import { useSignInCommandV1 } from '@Organizations/Users/commands-vue-composables'

    
export default /*@__PURE__*/_defineComponent({
  __name: 'SigninPage',
  setup(__props) {

    const route = useRoute()
    const router = useRouter()

    const returnUrl = computed<string | undefined>(() =>
    {
        const v = route.query.returnUrl
        return Array.isArray(v) ? v[0] : v
    })


    const inputEmail = ref('')
    const inputPassword = ref('')
    const inputSignedInAsDifferentUser = ref(false)

    const inputEmailRef = ref<HTMLInputElement | null>(null)
    const inputPasswordRef = ref<HTMLInputElement | null>(null)

    const { runCurrentUserQueryV1, modelCurrentUserQueryV1: userSessionDetails } =
        useCurrentUserQueryV1(false, false, false)


    const email = computed(() => userSessionDetails.value?.Email)
    const isAuthenticated = computed(() => result.value?.IsAuthenticated || false)
    const accessUrl = computed(() => result.value?.AccessUrl || null)


    const {
        invokeSignInCommandV1,
        invokingSignInCommandV1,
        validationErrors,
        succeedSignInCommandV1,
        errorSignInCommandV1,
        result
    } = useSignInCommandV1(inputEmail, inputPassword, returnUrl)


    const isInitial = computed(() =>
        !invokingSignInCommandV1.value &&
        !succeedSignInCommandV1.value &&
        !errorSignInCommandV1.value)

    const isInvoking = computed(() => invokingSignInCommandV1.value === true)
    const isInvalid = computed(() => validationErrors.value?.length > 0)
    const isFailed = computed(() => errorSignInCommandV1.value != null)


    const signInFormVisible = computed(() =>
        userSessionDetails.value &&
        !isAuthenticated.value &&
        (!email.value || inputSignedInAsDifferentUser.value)
    )

    const signedInAlertVisible = computed(() =>
        email.value && !inputSignedInAsDifferentUser.value
    )

    const signinCommandEnabled = computed(() =>
        isInitial.value || isInvalid.value
    )


    const unableToAuthenticate = computed(() =>
        result.value && !result.value.IsAuthenticated
    )

    onMounted(() =>
    {
        document.title = 'Sign in to TransparentChoice'
        runCurrentUserQueryV1()
    })

    // ----------------------------------
    // handlers
    // ----------------------------------

    function handleSignInCommandV1()
    {
        if (!inputEmail.value)
        {
            inputEmailRef.value?.focus()
            return
        }

        if (!inputPassword.value)
        {
            inputPasswordRef.value?.focus()
            return
        }

        invokeSignInCommandV1()
    }

    function handleTryAgain()
    {
        window.location.reload()
    }


    // ----------------------------------
    // redirect (replaces watcher on getter)
    // ----------------------------------

    watch(isAuthenticated, (ok) =>
    {
        if (ok && accessUrl.value)
        {
            window.location.href = accessUrl.value
        }
    })

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    (signInFormVisible.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _withDirectives(_createElementVNode("div", null, [
            _cache[6] || (_cache[6] = _createElementVNode("h3", { class: "fg-color-blue" }, "Sign in to TransparentChoice", -1 /* CACHED */)),
            _cache[7] || (_cache[7] = _createElementVNode("br", null, null, -1 /* CACHED */)),
            _createElementVNode("div", _hoisted_2, [
              _cache[3] || (_cache[3] = _createElementVNode("label", null, "Email:", -1 /* CACHED */)),
              _withDirectives(_createElementVNode("input", {
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((inputEmail).value = $event)),
                ref_key: "inputEmailRef",
                ref: inputEmailRef,
                type: "email",
                class: "form-control",
                placeholder: "Email address",
                onKeyup: _withKeys(handleSignInCommandV1, ["enter"]),
                autofocus: ""
              }, null, 544 /* NEED_HYDRATION, NEED_PATCH */), [
                [_vModelText, inputEmail.value]
              ]),
              _createVNode(ValidationError, {
                context: "Email",
                errors: _unref(validationErrors)
              }, null, 8 /* PROPS */, ["errors"])
            ]),
            _createElementVNode("div", _hoisted_3, [
              _cache[4] || (_cache[4] = _createElementVNode("label", null, "Password:", -1 /* CACHED */)),
              _withDirectives(_createElementVNode("input", {
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((inputPassword).value = $event)),
                ref_key: "inputPasswordRef",
                ref: inputPasswordRef,
                type: "password",
                class: "form-control",
                placeholder: "Password",
                onKeyup: _withKeys(handleSignInCommandV1, ["enter"])
              }, null, 544 /* NEED_HYDRATION, NEED_PATCH */), [
                [_vModelText, inputPassword.value]
              ]),
              _cache[5] || (_cache[5] = _createElementVNode("div", { class: "text-right" }, [
                _createElementVNode("a", {
                  href: "/#/organizations/users/requestresetpassword",
                  class: "text-dark"
                }, "Forgot password?")
              ], -1 /* CACHED */))
            ]),
            _cache[8] || (_cache[8] = _createElementVNode("div", null, [
              _createElementVNode("div", { class: "error" }, [
                _createElementVNode("br")
              ])
            ], -1 /* CACHED */)),
            _withDirectives(_createElementVNode("button", {
              onClick: handleSignInCommandV1,
              onKeyup: _withKeys(handleSignInCommandV1, ["enter"]),
              class: "btn btn-lg btn-primary btn-block"
            }, "Sign in", 544 /* NEED_HYDRATION, NEED_PATCH */), [
              [_vShow, signinCommandEnabled.value]
            ]),
            _withDirectives(_createElementVNode("button", _hoisted_4, "Signing in...", 512 /* NEED_PATCH */), [
              [_vShow, isInvoking.value]
            ]),
            _cache[9] || (_cache[9] = _createElementVNode("br", null, null, -1 /* CACHED */)),
            _createCommentVNode("<span>\n                <span>Don't have an account?</span>\n                <a href=\"/#/organizations/users/requestaccount\">Request access</a>\n            </span>"),
            _cache[10] || (_cache[10] = _createElementVNode("hr", null, null, -1 /* CACHED */)),
            _cache[11] || (_cache[11] = _createElementVNode("br", null, null, -1 /* CACHED */)),
            _cache[12] || (_cache[12] = _createElementVNode("a", {
              href: "/#/organizations/users/sso",
              class: "btn btn-secondary btn-lg btn-block"
            }, "Sign in with SSO", -1 /* CACHED */))
          ], 512 /* NEED_PATCH */), [
            [_vShow, isInitial.value || isInvoking.value || isInvalid.value]
          ]),
          _withDirectives(_createElementVNode("div", null, [
            _cache[13] || (_cache[13] = _createStaticVNode("<h3 class=\"fg-color-blue\">Unable to sign-in</h3><br><p>There can be many reasons for this, eg.:</p><ul><li>email and password mismatch</li><li>typo or caps lock is enabled</li><li>account does not exist</li><li>no roles assigned</li><li>account is locked (eg. due to inactivity)</li><li>your access request is pending or was rejected</li></ul><p> Please check your email for any alerts. You can also request reset your password <a href=\"/#/organizations/users/requestresetpassword\">here</a>. </p><br>", 6)),
            _createElementVNode("button", {
              onClick: handleTryAgain,
              class: "btn btn-lg btn-primary btn-block"
            }, "Try again")
          ], 512 /* NEED_PATCH */), [
            [_vShow, unableToAuthenticate.value]
          ])
        ]))
      : _createCommentVNode("v-if", true),
    (signedInAlertVisible.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
          _createElementVNode("h3", _hoisted_6, "You are already signed in as " + _toDisplayString(email.value), 1 /* TEXT */),
          _cache[14] || (_cache[14] = _createElementVNode("br", null, null, -1 /* CACHED */)),
          _createElementVNode("button", {
            onClick: _cache[2] || (_cache[2] = ($event: any) => (inputSignedInAsDifferentUser.value=true)),
            class: "btn btn-lg btn-primary btn-block"
          }, "Sign in as a different user"),
          _cache[15] || (_cache[15] = _createElementVNode("a", {
            href: "/",
            class: "btn btn-lg btn-secondary btn-block"
          }, "Go to my account", -1 /* CACHED */))
        ]))
      : _createCommentVNode("v-if", true)
  ]))
}
}

})